import PropTypes from 'prop-types';
import { Card, LoaderSkeleton } from '@utilities';

import Prompts from './components/Prompts';
import Results from './components/Results';

import styles from './_index.module.scss';

const BodyCard = ({
  activePrompt,
  fastTrackId,
  getPillTooltip,
  getPillValue,
  isLoading,
  onAnswerChange,
  prompts,
  sameLevelPrompts,
  searchPrompts,
  selectedAnswers,
  setActivePrompt,
  setSelectedAnswers,
  transformedAnswersMap,
  type,
}) => {
  if (isLoading || !prompts?.length || !activePrompt) {
    return (
      <Card className={`${styles['body-card']} ${styles['placeholder-body-card']}`}>
        <LoaderSkeleton height={400} width={1020}>
          <rect height="40" rx="12" ry="12" width="260" x="0" y="0" />
          <rect height="40" rx="12" ry="12" width="260" x="0" y="60" />
          <rect height="40" rx="12" ry="12" width="260" x="0" y="120" />
          <rect height="40" rx="12" ry="12" width="260" x="0" y="180" />
          <rect height="40" rx="12" ry="12" width="260" x="0" y="240" />
          <rect height="15" rx="4" ry="4" width="160" x="280" y="0" />
          <rect height="15" rx="4" ry="4" width="140" x="280" y="30" />
          <rect height="15" rx="4" ry="4" width="150" x="280" y="60" />
          <rect height="15" rx="4" ry="4" width="130" x="280" y="90" />
          <rect height="15" rx="4" ry="4" width="160" x="280" y="120" />
          <rect height="15" rx="4" ry="4" width="125" x="280" y="150" />
          <rect height="15" rx="4" ry="4" width="145" x="280" y="180" />
          <rect height="15" rx="4" ry="4" width="150" x="280" y="210" />
          <rect height="15" rx="4" ry="4" width="130" x="480" y="0" />
          <rect height="15" rx="4" ry="4" width="140" x="480" y="30" />
          <rect height="15" rx="4" ry="4" width="110" x="480" y="60" />
          <rect height="15" rx="4" ry="4" width="120" x="480" y="90" />
          <rect height="15" rx="4" ry="4" width="130" x="480" y="120" />
          <rect height="15" rx="4" ry="4" width="100" x="480" y="150" />
          <rect height="15" rx="4" ry="4" width="140" x="480" y="180" />
        </LoaderSkeleton>
      </Card>
    );
  }

  return (
    <Card className={styles['body-card']}>
      <Prompts
        activePrompt={activePrompt}
        getPillTooltip={getPillTooltip}
        getPillValue={getPillValue}
        prompts={prompts}
        setActivePrompt={setActivePrompt}
        setSelectedAnswers={setSelectedAnswers}
        transformedAnswersMap={transformedAnswersMap}
        type={type}
      />
      <Results
        activePrompt={activePrompt}
        fastTrackId={fastTrackId}
        onAnswerChange={onAnswerChange}
        sameLevelPrompts={sameLevelPrompts}
        searchPrompts={searchPrompts}
        selectedAnswers={selectedAnswers}
        setSelectedAnswers={setSelectedAnswers}
        transformedAnswersMap={transformedAnswersMap}
      />
    </Card>
  );
};

BodyCard.propTypes = {
  activePrompt: PropTypes.object,
  fastTrackId: PropTypes.string,
  getPillTooltip: PropTypes.func,
  getPillValue: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func.isRequired,
  prompts: PropTypes.array.isRequired,
  sameLevelPrompts: PropTypes.array,
  searchPrompts: PropTypes.array,
  selectedAnswers: PropTypes.object,
  setActivePrompt: PropTypes.func,
  setSelectedAnswers: PropTypes.func,
  transformedAnswersMap: PropTypes.object,
  type: PropTypes.string,
};

export default BodyCard;
